"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intercepterMessageType = exports.intercepterMessageHandler = void 0;
var _intercepterMessageMapping = require("./intercepterMessageMapping");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var intercepterMessageHandler = function intercepterMessageHandler(toast, progressToaster, response, messageType, logoutSystem, user) {
  var _response$data, _response$data2, _response$data2$data, _response$data5, _response$config2, _response$config2$url;
  if (response.config.url.includes("api/refreshToken")) return response;
  if (response.config.url.includes("/assetsservice/v1/api/asset/preview?assetFolderViewId=") && typeof (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) === "string" && response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && (_response$data2$data = _response$data2.data) !== null && _response$data2$data !== void 0 && _response$data2$data.includes("player.vimeo.com")) {
    toast.warning({
      description: intercepterMessageType.wistiaMigrationMessage
    });
  }
  if (messageType === intercepterMessageType.success) {
    var _response$data3, _response$data4, _response$config;
    var mappingMessage = getAPIUrl(response.config);
    sessionStorage.removeItem(process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY);
    if (mappingMessage === "SKIP_GENERIC_MSG") return response;
    if (skipBackendSuccessValidation(response)) return response;
    if (response.config.url.includes("edit/brand/change") && (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 202) {
      setTimeout(function () {
        toast.success({
          title: intercepterMessageType.acceptedTitle,
          description: intercepterMessageType.themeApplied
        });
      }, 200);
    } else if (response.config.url.includes("api/asset/download/url") && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 400) {
      setTimeout(function () {
        toast.warning({
          description: mappingMessage || intercepterMessageType.noFileFoundMessage
        });
      }, 200);
    } else {
      switch (response.data.code) {
        case intercepterMessageType.createdCode:
          if (mappingMessage != "SKIP_GENERIC_ALERT") {
            setTimeout(function () {
              toast.success({
                title: intercepterMessageType.createdTitle,
                description: mappingMessage || intercepterMessageType.createdMessage
              });
            }, 200);
          }
          break;
        case intercepterMessageType.noDataFound:
          setTimeout(function () {
            toast.warning({
              title: "Info",
              description: mappingMessage || intercepterMessageType.noDataFoundMessage
            });
          }, 200);
          break;
        case intercepterMessageType.acceptedCode:
          if (mappingMessage != "SKIP_GENERIC_ALERT") {
            setTimeout(function () {
              toast.success({
                title: intercepterMessageType.acceptedTitle,
                description: mappingMessage || intercepterMessageType.acceptedMessage
              });
            }, 200);
          }
          break;
        case intercepterMessageType.notfound:
          if (skipBackendErrorValidation(response)) return response;
          toast.danger({
            title: intercepterMessageType.notfoundTitle,
            description: getErrorMessage(response.data)
          });
          break;
        case intercepterMessageType.forbidden:
          toast.danger({
            title: intercepterMessageType.forbiddenTitle,
            description: intercepterMessageType.forbiddenMessage
          });
          break;
        case intercepterMessageType.multiStatusCode:
          if (response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && _response$data5.data) {
            response.mappingMessage = mappingMessage || "";
            progressToaster.success({
              response: response
            });
          } else {
            toast.success({
              title: intercepterMessageType.multiStatusTitle,
              description: mappingMessage || intercepterMessageType.multiStatusMessage
            });
          }
          break;
      }
    }
    if ((response === null || response === void 0 ? void 0 : (_response$config = response.config) === null || _response$config === void 0 ? void 0 : _response$config.responseType) === "arraybuffer" && response.headers["content-type"] === "application/json") {
      setTimeout(function () {
        var _response$data6;
        if (response.config.url.includes("api/analytics/snapshot/download") && (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 200) {
          toast.warning({
            description: intercepterMessageType.SnapshotNotFoundMessage
          });
        } else {
          toast.warning({
            description: mappingMessage || intercepterMessageType.noFileFoundMessage
          });
        }
      }, 201);
    }
  } else {
    var _response$data7;
    switch (response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.code) {
      case intercepterMessageType.tokenExpired:
        if (response !== null && response !== void 0 && (_response$config2 = response.config) !== null && _response$config2 !== void 0 && (_response$config2$url = _response$config2.url) !== null && _response$config2$url !== void 0 && _response$config2$url.includes("api/records/public/login")) {
          localStorage.setItem("loginUrl", window.location.href);
        } else {
          toast.danger({
            title: intercepterMessageType.tokenExpiredTitle,
            description: intercepterMessageType.tokenExpiredMessage
          });
        }
        logoutSystem(response);
        break;
      case intercepterMessageType.notfound:
        if (skipBackendBadRequestValidation(response)) return response;
        toast.danger({
          title: user ? intercepterMessageType.notfoundTitle : intercepterMessageType.networkTitle,
          description: getErrorMessage(response.data)
        });
        break;
      default:
        toast.danger({
          title: intercepterMessageType.networkTitle,
          description: intercepterMessageType.internalErrorMessage
        });
    }
  }
};
exports.intercepterMessageHandler = intercepterMessageHandler;
var skipBackendErrorValidation = function skipBackendErrorValidation(response) {
  var _response$data8, _response$data9, _response$data10, _response$data10$data, _response$data11, _response$data11$data, _response$data11$data2, _response$data12, _response$data13, _response$data13$data, _response$data14, _response$data14$data, _response$data14$data2, _response$data15, _response$data16;
  if ((response.config.url.includes("/api/records/donors/passcode") || response.config.url.includes("/api/records/funds/link") || response.config.url.includes("/api/records/funds/link/single") || response.config.url.includes("/api/records/funds/unlink/single")) && typeof (response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.data) === "string" && (response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 400) {
    return false;
  }
  if ((response.config.url.includes("api/account/disable") || response.config.url.includes("api/site/render") || response.config.url.includes("api/export/analytics/report/snapshot/live") || response.config.url.includes("api/export/analytics/site/snapshot/live") || response.config.url.includes("api/analytics/session/site") || response.config.url.includes("api/analytics/session/report") || response.config.url.includes("api/report/render") || response.config.url.includes("/api/general/reset-password") || response.config.url.includes("api/account/enable") || response.config.url.includes("api/account/clean") || response.config.url.includes("api/account/delete") || response.config.url.includes("api/account/bulk/clean") || response.config.url.includes("api/account/bulk/delete") || response.config.url.includes("api/account/bulk/disable") || response.config.url.includes("api/general/validate/password") || response.config.url.includes("api/account/bulk/enable") ||
  // response.config.url.includes("api/report/data/fund") ||
  response.config.url.includes("/api/user/unique/email") || response.config.url.includes("/api/organization/platform") || response.config.url.includes("analytics/data-and-alert/send-notification") || response.config.url.includes("/api/organization") && (response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : (_response$data10$data = _response$data10.data) === null || _response$data10$data === void 0 ? void 0 : _response$data10$data.length) > 0 && (response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : (_response$data11$data = _response$data11.data) === null || _response$data11$data === void 0 ? void 0 : (_response$data11$data2 = _response$data11$data.filter(function (d) {
    var _d$email;
    return (d === null || d === void 0 ? void 0 : d.name) === "Organization Name already exists" || (d === null || d === void 0 ? void 0 : (_d$email = d.email) === null || _d$email === void 0 ? void 0 : _d$email.includes("is already present")) || (d === null || d === void 0 ? void 0 : d.colIdpLoginUrn) === "field can not be empty" || (d === null || d === void 0 ? void 0 : d.colIdpLogoutUrn) === "field can not be empty" || (d === null || d === void 0 ? void 0 : d.colMaxReports) === "field can not be empty";
  })) === null || _response$data11$data2 === void 0 ? void 0 : _response$data11$data2.length) > 0 ||
  // (response.config.url.includes("/api/user") &&
  //   !response.config.url.includes("/api/user/admin/platform")) ||
  response.config.url.includes("/api/records/unique/url-extension") || response.config.url.includes("/api/report/data/impact/unique/impact-reference-no") || response.config.url.includes("/api/records/unique/reference-no") || response.config.url.includes("/api/records/donors/passcode") && (response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.data) === "Password does not match." || response.config.url.includes("/api/records") && (response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : (_response$data13$data = _response$data13.data) === null || _response$data13$data === void 0 ? void 0 : _response$data13$data.length) > 0 && (response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : (_response$data14$data = _response$data14.data) === null || _response$data14$data === void 0 ? void 0 : (_response$data14$data2 = _response$data14$data.filter(function (d) {
    return (d === null || d === void 0 ? void 0 : d.colRecordReferenceNo) === "Duplicate record number." || (d === null || d === void 0 ? void 0 : d.colRecordReferenceNo2) === "Duplicate record number." || (d === null || d === void 0 ? void 0 : d.colRecordReferenceNo3) === "Duplicate record number." || (d === null || d === void 0 ? void 0 : d.colRecordReferenceNo4) === "Duplicate record number." || (d === null || d === void 0 ? void 0 : d.colRecordSpouseOrPartnerReferenceNo) === "Duplicate record number.";
  })) === null || _response$data14$data2 === void 0 ? void 0 : _response$data14$data2.length) > 0 || response.config.url.includes("/api/report/list/build") && (response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.data[0].colFiscalYear) === "Must not be null.") && (response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.code) === 400) {
    return true;
  }
  if (response.config.url.includes("api/general/save-password")) {
    return true;
  }
  return false;
};
var skipBackendBadRequestValidation = function skipBackendBadRequestValidation(response) {
  var skipUrls = ["/api/report/data/impact", "/api/report/editor/lock", "api/site/editor/lock", "api/content-panel/editor/lock"];
  var skipCodes = [400];
  var url = response.config.url;
  var data = response.data;
  if (skipUrls.some(function (skipUrl) {
    return url.includes(skipUrl);
  })) {
    return skipCodes.some(function (skipCode) {
      return skipCode === (data === null || data === void 0 ? void 0 : data.code);
    });
  }
  return false;
};
var skipBackendSuccessValidation = function skipBackendSuccessValidation(response) {
  if (response.config.url.includes("/assetsservice/v1/api/asset/upload/image/fund/default") || response.config.url.includes("/assetsservice/v1/api/asset/upload/image/impact/default") || response.config.url.includes("/assetsservice/v1/api/asset/upload/image/printbridge/default")) {
    return false;
  }
  var skipUrls = ["api/user/admin/system/email", "api/asset/upload/image/user", "api/asset/upload/vcard/user", "api/user/activities", "api/analytics/session/site", "api/analytics/session/report", "api/authenticate/logout", "api/general/validate/token?forgotPasswordToken", "api/general/authorize-device", "authenticate/delegate-access",
  // "api/report/data/impact",
  "general/save-password", "general/forgot-password/mail", "api/asset/upload/image/fund", "api/asset/upload/image/impact", "api/asset/upload/image", "analytics/data-and-alert/send-notification", "api/analytics/session/cookie/status"];
  if (window.location.pathname.includes("reportdata")) {
    var index = skipUrls.indexOf("api/report/data/impact");
    skipUrls.splice(index, 1);
  }
  var skipCodes = [201, 202];
  var url = response.config.url;
  var data = response.data;
  if (skipUrls.some(function (skipUrl) {
    return url.includes(skipUrl);
  })) {
    return skipCodes.some(function (skipCode) {
      return skipCode === (data === null || data === void 0 ? void 0 : data.code);
    });
  }
  return false;
};
var getAPIUrl = function getAPIUrl(responseConfig) {
  var _responseConfig$url, _mappingObj$;
  var sessionMessage = sessionStorage.getItem(process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY);
  if (sessionMessage === "SKIP_GENERIC_MSG") return "SKIP_GENERIC_MSG";
  if (sessionMessage) return sessionMessage;
  var url = responseConfig === null || responseConfig === void 0 ? void 0 : (_responseConfig$url = responseConfig.url) === null || _responseConfig$url === void 0 ? void 0 : _responseConfig$url.split("?");
  var mappingObj = _intercepterMessageMapping.intercepterMessageMapping.filter(function (item) {
    return item.url === url[0] && item.method === responseConfig.method;
  });
  if (mappingObj && (_mappingObj$ = mappingObj[0]) !== null && _mappingObj$ !== void 0 && _mappingObj$.message) return mappingObj[0].message;else return "";
};
var getErrorMessage = function getErrorMessage(response) {
  if (_typeof(response === null || response === void 0 ? void 0 : response.data) === "object") {
    var _response$data17;
    var error = "";
    if ((response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.length) > 0) {
      var _response$data18;
      response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.forEach(function (item) {
        Object.values(item).forEach(function (msg) {
          error += msg + ", ";
        });
      });
      return error.slice(0, -2);
    } else {
      return response === null || response === void 0 ? void 0 : response.message;
    }
  } else if (typeof (response === null || response === void 0 ? void 0 : response.data) === "string") {
    return (response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : response.message);
  }
};
var intercepterMessageType = {
  danger: "danger",
  success: "success",
  acceptedCode: 202,
  createdCode: 201,
  noDataFound: 204,
  wistiaMigrationMessage: "Migration in Progress.",
  noDataFoundMessage: "No data found.",
  noFileFoundMessage: "Data not found or unreadable.",
  SnapshotNotFoundMessage: "Pdf is getting generated; please try again after 2 mins.",
  noDataFoundTitle: "Info",
  notfound: 400,
  forbidden: 403,
  multiStatusCode: 207,
  multiStatusTitle: "Success",
  multiStatusMessage: "Multi status performed successfully",
  createdTitle: "Success",
  createdMessage: "Created successfully.",
  acceptedTitle: "Success",
  acceptedMessage: "Accepted successfully.",
  themeApplied: "Theme applied and saved.",
  notfoundTitle: "Error",
  forbiddenTitle: "Forbidden",
  forbiddenMessage: "You are not authorised to access this action or service.",
  networkTitle: "Error",
  internalErrorMessage: "There is an internal error or an issue with your network. Please check your network connection.",
  tokenExpired: 401,
  tokenExpiredTitle: "Session expired",
  AccessDeniedNotHavePermissionReport: "Access denied. You do not have permission to build report(s).",
  AccessDeniedNotHavePermissionSite: "Access denied. You do not have permission to build site(s).",
  tokenExpiredMessage: "Your session has been expired, please try to login again."
};
exports.intercepterMessageType = intercepterMessageType;